export default __webpack_public_path__ + "static/media/choose-fb-pages-en.71208665.png";